import * as angular from 'angular';
import ReportsBridge from './ReportsBridge';

angular
  .module('flowingly.runner.reportsv2')
  .component('reports', ReportsBridge);
